import dayjs from 'dayjs';
import { getDateTz } from '../helpers/date';
import 'dayjs/locale/de';
import 'dayjs/locale/en';

export default {
  props: {
    value: {
      type: Object,
      default: undefined,
    },
    rules: {
      type: [String, Object],
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    options: {
      type: Array,
      default: () => [],
    },
    dateFormat: {
      type: String,
      default: undefined,
    },
    timeFormat: {
      type: String,
      default: undefined,
    },
    commonDesignOptions: {
      type: Object,
      default: () => {},
    },
    validationTextError: {
      type: String,
      required: true,
    },
    translation: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isMaxSeatsEnabled: {
      type: Boolean,
      default: false,
    },
    maxSeatsNumber: {
      type: Number,
      default: undefined,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      required: true,
      validate: (value) => ['en_EN', 'de_DE'].includes(value),
    },
  },
  computed: {
    cssProps() {
      const {
        fieldBorder, fieldBorderSize, labelColor, labelFontSize, primaryColor, primaryColorHover,
        fieldPlaceholderColor, fieldBackgroundColor, fieldIconColor, fieldTextSize, fieldTextColor,
        fieldBorderRadius, fieldBorderColor,
      } = this.commonDesignOptions;
      return {
        '--label-color': labelColor,
        '--label-font-size': `${labelFontSize}px`,
        '--primary-color': primaryColor,
        '--primary-hover-color': primaryColorHover,
        '--primary-active-color': this.hexToRgb(primaryColor, 0.2),
        '--placeholder-color': fieldPlaceholderColor,
        '--input-bg-color': fieldBackgroundColor,
        '--input-icon-color': fieldIconColor,
        '--input-font-size': `${fieldTextSize}px`,
        '--input-font-color': fieldTextColor,
        '--input-border-radius': `${fieldBorderRadius}px`,
        '--input-border-color': fieldBorderColor,
        '--input-border-top': `${fieldBorder.includes('top') ? fieldBorderSize : 0}px`,
        '--input-border-left': `${fieldBorder.includes('left') ? fieldBorderSize : 0}px`,
        '--input-border-right': `${fieldBorder.includes('right') ? fieldBorderSize : 0}px`,
        '--input-border-bottom': `${fieldBorder.includes('bottom') ? fieldBorderSize : 0}px`,
      };
    },
    isBelowMessage() {
      return this.commonDesignOptions.positionValidationMessage === 'below';
    },
    isAboveMessage() {
      return this.commonDesignOptions.positionValidationMessage === 'above';
    },
  },
  filters: {
    asDate(value, format, language) {
      const mapping = {
        en_EN: 'en',
        de_DE: 'de',
      };
      return getDateTz(value)
        .locale(mapping[language])
        .format(format);
    },
  },
  methods: {
    isActive(option) {
      return this.value && this.value.time.gmt.timestamp === option.time.gmt.timestamp;
    },
    hexToRgb(hex, opacity = 1) {
      const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex)
        .slice(1, 4)
        .map((value) => Number.parseInt(value, 16));
      return `rgba(${result[0]}, ${result[1]}, ${result[2]}, ${opacity})`;
    },
    getAvailablePlaces(ts) {
      const x = (getDateTz(ts).unix() - dayjs().unix()) / 3600;
      return +(Math.ceil(x + Math.sin(x) + 1));
    },
    getTranslatePlace(ts) {
      let count = this.getAvailablePlaces(ts);
      let total = '';
      if (this.isMaxSeatsEnabled) {
        total = this.translation.total.replace('{total}', this.maxSeatsNumber);
        if (count > this.maxSeatsNumber) {
          count = this.maxSeatsNumber - 1;
        }
      }
      if (count < 1) {
        count = 1;
      }
      const result = this.translation.placesStillAvailable.replace('{count}', count);
      return `${result} ${total}`.trim();
    },
  },
};
